module.exports = __webpack_public_path__ + "static/img/exhibit.15d4dcf1.png";